/** Retry only webpack asset downloads, before React mounts the page.
 * Keeping the same lazy promise pending avoids remounting forms or replaying
 * page effects. Never reload the document: other mounted UI may contain edits.
 */
export async function importWithRetry<T>(load: () => Promise<T>): Promise<T> {
  const delays = [500, 1500];
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await load();
    } catch (error) {
      const assetError = error as { name?: string; code?: string; message?: string };
      const recoverable =
        (assetError?.name === 'ChunkLoadError' &&
          /^Loading chunk .+ failed\./.test(assetError.message || '')) ||
        (assetError?.code === 'CSS_CHUNK_LOAD_FAILED' &&
          /^Loading CSS chunk .+ failed\./.test(assetError.message || ''));
      if (!recoverable || attempt >= delays.length) throw error;
      await new Promise((resolve) => setTimeout(resolve, delays[attempt]));
    }
  }
}
